import React, { useEffect } from 'react';
import { Navbar } from '../../components/Navbar';
import { StickyFooter } from '../../components/StickyFooter';
import { ShieldCheckIcon, MapPinIcon, CalendarIcon } from 'lucide-react';
export function TravelNursesUS() {
  useEffect(() => {
    document.title = "Travel Nurse & Medical Tech Matching Platform | Care Nomad US";
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2403" data-mp="1aa2epl4cbi00">
      <Navbar data-id="element-2404" data-mp="1ed8upkh98njo" />
      
      <main className="flex-1" data-id="element-2405" data-mp="1ebxrblrq1ht3">
        {/* Hero Section */}
        <section className="w-full relative py-12 lg:py-16 flex items-center justify-center min-h-[40vh]" data-id="element-2406" data-mp="1jc1ygl6qp06n">
          <div className="absolute inset-0 z-0" data-id="element-2407" data-mp="1o54tkxr60hoy">
            <img src="https://images.unsplash.com/photo-1584515933487-779824d29309?w=1200&auto=format&fit=crop" alt="Travel Nurses Background" className="w-full h-full object-cover" data-id="element-2408" data-mp="1t2wuuidp9g5t" />
            <div className="absolute inset-0 bg-[#1a2332]/80" data-id="element-2409" data-mp="1xzwtw9c4tinf"></div>
          </div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-2410" data-mp="223urgflt6led">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-4" data-id="element-2411" data-mp="219ahonmk0fdb">
              Travel Nurse & Medical Tech Matching Platform
            </h1>
            <p className="text-base sm:text-lg text-white/90 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-2412" data-mp="1ral3p5xs3f2c">
              Connecting travel RNs, LPNs, and allied health professionals with regional facilities and private contracts across the NC Triangle.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-2413" data-mp="2eze2da5sc10n">
              <a href="#inquiry" className="bg-[#007a87] hover:bg-[#005c66] text-white font-bold py-3 px-8 rounded-full transition-colors text-base shadow-md" data-id="element-2414" data-mp="2f178mochkj84">
                Find Contracts
              </a>
            </div>
          </div>
        </section>

        {/* Specialties */}
        <section className="py-20 bg-gray-50" data-id="element-2415" data-mp="32pzwrymv9ms6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2416" data-mp="2xy8cu6y7ufb0">
            <div className="text-center mb-16" data-id="element-2417" data-mp="2xvvrrkx5votq">
              <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-2418" data-mp="w06f8zr5os41">Browse by Specialty</h2>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-2419" data-mp="10yhop9djh0lq">
              {['ICU / Critical Care', 'Med-Surg', 'Emergency Room (ER)', 'Rehab / LTC', 'Labor & Delivery', 'Operating Room', 'Telemetry', 'Allied Health'].map((spec, idx) => <div key={idx} className="bg-white p-6 rounded-xl border border-gray-200 text-center hover:border-[#007a87] transition-colors cursor-pointer shadow-sm" data-id="element-2420" data-mp="r7dawczlnlsh" data-mpi={idx}>
                  <h3 className="font-bold text-[#1a2332]" data-id="element-2421" data-mp="hcv1qsbeyy1a">{spec}</h3>
                </div>)}
            </div>
          </div>
        </section>

        {/* Inquiry Form */}
        <section id="inquiry" className="py-20 bg-white" data-id="element-2422" data-mp="8bn50eojq59b">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2423" data-mp="1xq1q8p0cva02">
            <div className="bg-white p-8 lg:p-12 rounded-3xl shadow-xl border border-gray-100" data-id="element-2424" data-mp="1xnp6q7ey8rkw">
              <div className="text-center mb-10" data-id="element-2425" data-mp="22mse3yiej9w1">
                <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-2426" data-mp="3n64c86o1a6kq">Placement Inquiry</h2>
                <p className="text-[#5a6a7a]" data-id="element-2427" data-mp="3i8ly81v5t15v">Submit your details to match with open contracts in Raleigh, Durham, and Chapel Hill.</p>
              </div>
              
              <form className="space-y-6" data-id="element-2428" data-mp="3s60eo1h31py6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2429" data-mp="3s4z1nrgiatdt">
                  <div data-id="element-2430" data-mp="9rr8zp7abfa9">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2431" data-mp="9qzmd3vo0rw4">First Name</label>
                    <input type="text" className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-[#007a87] focus:outline-none" required data-id="element-2432" data-mp="4rwhpkjlknoo" />
                  </div>
                  <div data-id="element-2433" data-mp="equ8yv8eqvbd">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2434" data-mp="ern8pc8y8kk0">Last Name</label>
                    <input type="text" className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-[#007a87] focus:outline-none" required data-id="element-2435" data-mp="2li3hvjj2oumz" />
                  </div>
                </div>
                <div data-id="element-2436" data-mp="17ladiadtfpi2">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2437" data-mp="1ckmwul5haefw">Credential</label>
                  <select className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-[#007a87] focus:outline-none bg-white" data-id="element-2438" data-mp="1hjq328x72qpg">
                    <option data-id="element-2439" data-mp="1lk0azr4jrr6y">Registered Nurse (RN)</option>
                    <option data-id="element-2440" data-mp="ovarxxh6osje">Licensed Practical Nurse (LPN)</option>
                    <option data-id="element-2441" data-mp="osy08slmj3t5">Certified Nursing Assistant (CNA)</option>
                    <option data-id="element-2442" data-mp="tux5k80xcasq">Allied Health Tech</option>
                  </select>
                </div>
                <div data-id="element-2443" data-mp="xuxj7qg78hyq">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2444" data-mp="xtme9nb0p461">Primary Specialty</label>
                  <input type="text" placeholder="e.g. ICU, ER" className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-[#007a87] focus:outline-none" required data-id="element-2445" data-mp="12ojt5auza7qu" />
                </div>
                <button type="submit" className="w-full bg-[#5a55ea] hover:bg-[#4b47c4] text-white font-bold py-4 rounded-xl transition-colors text-lg" data-id="element-2446" data-mp="2mn5om5w7ua7">
                  Submit Inquiry
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>

      <StickyFooter data-id="element-2447" data-mp="3pt622gomr91g" />
    </div>;
}